import React, { useRef, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import BtnLink from '../CustomLink/BtnLink';
import { useSendPasswordResetEmail, useSignInWithEmailAndPassword, useSignInWithGoogle} from 'react-firebase-hooks/auth';
import { useLocation, useNavigate } from 'react-router-dom';
import auth from '../../firebase.init';
import './Login.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SocialLogin from '../SocialLogin/SocialLogin';


const Login = () => {

    const [sendPasswordResetEmail, sending] = useSendPasswordResetEmail(auth);
    const [signInWithGoogle] = useSignInWithGoogle(auth);

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [
        signInWithEmailAndPassword,
        user,
        loading,
        error,
    ] = useSignInWithEmailAndPassword(auth);
    
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || '/';

    const handleEmailBlur = event => {
        setEmail(event.target.value);
    }

    const handlePasswordBlur = event => {
        setPassword(event.target.value);
    }

    if (user) {
        navigate(from, {replace: true});
    };

    if (loading || sending) {
        return ( <h3>Loading...</h3> );
    }

    const resetPassword = async () => {
        if (email) {
            await sendPasswordResetEmail(email);
            toast('Sent email');
        }
        else{
            toast('please enter your email address');
        }
    }

    const handleUserSignIn = event => {
        event.preventDefault();
        signInWithEmailAndPassword(email, password);
    }
    return (
        <div className='container'>
            <h2>Login Here</h2>
        <div className='mx-auto w-50'>
            
        <Form onSubmit={handleUserSignIn}>
 
        <Form.Group className="mb-3">
                        <Form.Label>Email address</Form.Label>
                        <Form.Control  onBlur={handleEmailBlur} type="email" placeholder="Enter email" />
                        <Form.Text className="text-muted">
                            We'll never share your email with anyone else.
                        </Form.Text>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Password</Form.Label>
                        <Form.Control onBlur={handlePasswordBlur} type="password" placeholder="Password" />
                    </Form.Group>

                    <p style={{ color: 'red' }}>{error?.message}</p>
                    {
                        loading && <p>Loading...</p>
                    }

                    <Button variant="primary" type="submit">
                      Log In
                    </Button>
        </Form> 
      
        <p> Have you not an Account? Please <BtnLink to="/signup">Sign Up Now</BtnLink> </p>
     
 </div>
    <div> 
        <h3> Another Systems are below to Login Our Websites</h3>
        <p>Forget Password? <button className='btn btn-link text-primary pe-auto text-decoration-none' onClick={resetPassword}>Reset Password</button> </p>
        
     <SocialLogin></SocialLogin>
        <ToastContainer />
    </div>
</div>
    );
};

export default Login;